export function IneligibleIcon(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12' fill='none' {...props}>
      <g clipPath='url(#clip0_34216_25087)'>
        <path
          d='M10.5 6C10.5 8.48528 8.48528 10.5 6 10.5C3.51472 10.5 1.5 8.48528 1.5 6C1.5 3.51472 3.51472 1.5 6 1.5C8.48528 1.5 10.5 3.51472 10.5 6Z'
          stroke='#EF4444'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M4.5 5C4.5 4.72386 4.72386 4.5 5 4.5H7C7.27614 4.5 7.5 4.72386 7.5 5V7C7.5 7.27614 7.27614 7.5 7 7.5H5C4.72386 7.5 4.5 7.27614 4.5 7V5Z'
          stroke='#EF4444'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_34216_25087'>
          <rect width='12' height='12' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}
